import moment from "moment";
import numeral from "numeral";
function getFormatDate(date) {
  return moment(date).format("DD/MM/YYYY");
}

export default function (data) {
  let today = moment(new Date()).format("DD/MM/YYYY  h:mm A");
  let tableBody = [
    [
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: data.t("report_no"),
                bold: true,
                fontSize: 10,
                alignment: "left",
                margin: [0, 0, 0, 0],
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === node.table.body.length ? 1 : 0;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function (i, node) {
            return "#E8E9EC";
          },
          // vLineColor: function (i, node) {
          //     return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
          // },
        },
        margin: [0, 16, 0, 0],
      },
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: data.t("report_order_code"),
                bold: true,
                fontSize: 10,
                alignment: "left",
                margin: [0, 0, 0, 0],
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === node.table.body.length ? 1 : 0;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function (i, node) {
            return i === node.table.body.length
              ? "#E8E9EC"
              : "rgba(41, 47, 72, 0)";
          },
          // vLineColor: function (i, node) {
          //     return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
          // },
        },
        margin: [0, 16, 0, 0],
      },
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: data.t("report_item"),
                bold: true,
                fontSize: 10,
                alignment: "left",
                margin: [0, 0, 0, 0],
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === node.table.body.length ? 1 : 0;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function (i, node) {
            return i === node.table.body.length
              ? "#E8E9EC"
              : "rgba(41, 47, 72, 0)";
          },
          // vLineColor: function (i, node) {
          //     return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
          // },
        },
        margin: [0, 16, 0, 0],
      },
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: data.t("report_quantity"),
                bold: true,
                fontSize: 10,
                alignment: "left",
                margin: [0, 0, 0, 0],
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === node.table.body.length ? 1 : 0;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function (i, node) {
            return i === node.table.body.length
              ? "#E8E9EC"
              : "rgba(41, 47, 72, 0)";
          },
          // vLineColor: function (i, node) {
          //     return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
          // },
        },
        margin: [0, 16, 0, 0],
      },
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: data.t("report_date"),
                bold: true,
                fontSize: 10,
                alignment: "left",
                margin: [0, 0, 0, 0],
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === node.table.body.length ? 1 : 0;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function (i, node) {
            return i === node.table.body.length
              ? "#E8E9EC"
              : "rgba(41, 47, 72, 0)";
          },
          // vLineColor: function (i, node) {
          //     return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
          // },
        },
        margin: [0, 16, 0, 0],
      },
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: data.t("report_price"),
                bold: true,
                fontSize: 10,
                alignment: "left",
                margin: [0, 0, 0, 0],
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === node.table.body.length ? 1 : 0;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function (i, node) {
            return i === node.table.body.length
              ? "#E8E9EC"
              : "rgba(41, 47, 72, 0)";
          },
          // vLineColor: function (i, node) {
          //     return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
          // },
        },
        margin: [0, 16, 0, 0],
      },
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: data.t("report_bonus"),
                bold: true,
                fontSize: 10,
                alignment: "left",
                margin: [0, 0, 0, 0],
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === node.table.body.length ? 1 : 0;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function (i, node) {
            return i === node.table.body.length
              ? "#E8E9EC"
              : "rgba(41, 47, 72, 0)";
          },
          // vLineColor: function (i, node) {
          //     return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
          // },
        },
        margin: [0, 16, 0, 0],
      },
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: data.t("report_commission"),
                bold: true,
                fontSize: 10,
                alignment: "right",
                margin: [0, 0, 0, 0],
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === node.table.body.length ? 1 : 0;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function (i, node) {
            return i === node.table.body.length
              ? "#E8E9EC"
              : "rgba(41, 47, 72, 0)";
          },
          // vLineColor: function (i, node) {
          //     return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
          // },
        },
        margin: [0, 16, 0, 0],
      },
    ],
  ];

  let STT = 0;
  let totalBonus = 0;
  data.listOrders.forEach((order) => {
    let listItem = order.item.filter((item) => {
      let isHaveEmployee =
        item.employee &&
        item.employee.find(
          (employee) => employee.userCode == data.oneEmployee.userCode
        );
      return !!isHaveEmployee;
    });
    if (listItem.length == 0) return;
    listItem.forEach((item) => {
      let bonusItem = data.bonusEmployee.find(
        (bonus) =>
          bonus.itemCode == item.itemCode && bonus.orderCode == order.orderCode
      ); // kiểm tra trong đơn hàng này nhân viên có đc bonus ko
      let bonusType = 0;
      if (bonusItem) {
        bonusType =
          bonusItem.typeBonus == "percent"
            ? `${bonusItem.bonus * 100}%`
            : `${numeral(bonusItem.bonus).format("0,0")} ${
                data.setting.currencyCode
              }`;
        totalBonus += bonusItem.bonusTotal;
      }
      let commissionBonus = bonusItem ? bonusItem.bonusTotal : 0;
      STT++;
      tableBody.push([
        {
          text: STT,
          fontSize: 10,
          alignment: "left",
          margin: [0, 16, 0, 0],
        },
        {
          text: order.orderCode,
          alignment: "left",
          margin: [0, 16, 0, 0],
        },
        {
          text: item.itemName,
          fontSize: 10,
          alignment: "left",
          margin: [0, 16, 0, 0],
        },
        {
          text: item.quantity,
          fontSize: 10,
          alignment: "left",
          margin: [0, 16, 0, 0],
        },
        {
          text: moment(order.createdAt).format("DD MMM YYYY"),
          fontSize: 10,
          alignment: "left",
          margin: [0, 16, 0, 0],
        },
        {
          text: `${numeral(item.itemPrice * item.quantity).format("0,0")} ${
            data.setting.currencyCode
          }`,
          fontSize: 10,
          alignment: "left",
          margin: [0, 16, 0, 0],
        },
        {
          text: bonusType,
          fontSize: 10,
          alignment: "left",
          margin: [0, 16, 0, 0],
        },
        {
          text: `${numeral(commissionBonus).format("0,0")} ${
            data.setting.currencyCode
          }`,
          fontSize: 10,
          alignment: "right",
          margin: [0, 16, 0, 0],
        },
      ]);
    });
  });
  return {
    info: {
      title: "ReportEmployee",
      author: "Masspa",
      subject: "Report",
      keywords: "keywords for document",
    },
    content: [
      {
        columns: [
          {
            // % width
            width: "50%",
            alignment: "left",
            text: today,
          },
          {
            // % width
            width: "50%",
            alignment: "right",
            text: "Masspa 0.0.1",
          },
        ],
        // optional space between columns
        columnGap: 10,
      },
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: "",
                border: [false, false, false, true],
                margin: [0, 16, 0, 0],
              },
            ],
          ],
        },
      },
      {
        text: data.t("report_employee_report"),
        style: "header",
        margin: [0, 16, 0, 0],
      },
      {
        text: `Report for: ${data.oneEmployee.name} —— ${getFormatDate(
          data.from
        )} - ${getFormatDate(data.to)}`,
        text: [
          { text: `${data.t("report_report_for")}: ` },
          { text: data.oneEmployee.name, bold: true },
          { text: `— ${getFormatDate(data.from)} - ${getFormatDate(data.to)}` },
        ],
        alignment: "center",
        fontSize: 14,
        margin: [0, 6, 0, 16],
      },
      {
        table: {
          widths: [
            "5%",
            "12%",
            "25%",
            "8%",
            "12.5%",
            "12.5%",
            "12.5%",
            "12.5%",
          ],
          body: tableBody,
        },
        layout: {
          hLineWidth: function (i, node) {
            return 0;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          // hLineColor: function (i, node) {
          //     return (i === node.table.body.length) ? 'rgba(41, 47, 72, 0.15)' : 'rgba(41, 47, 72, 0)';
          // },
          // vLineColor: function (i, node) {
          //     return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
          // },
        },
      },
      {
        columns: [
          {
            // % width
            width: "50%",
            bold: true,
            alignment: "left",
            fontSize: 12,
            text: data.t("report_total_commission"),
            margin: [0, 6, 0, 0],
          },
          {
            // % width
            width: "50%",
            bold: true,
            alignment: "right",
            fontSize: 12,
            text: `${numeral(totalBonus).format("0,0")} ${
              data.setting.currencyCode
            }`,
            margin: [0, 6, 0, 0],
          },
        ],
        // optional space between columns
        columnGap: 10,
      },
      {
        columns: [
          {
            // % width
            width: "50%",
            alignment: "left",
            fontSize: 12,
            text: [
              { text: data.t("report_total_salary_commission"), bold: true },
              {
                text: ` (${numeral(data.oneEmployee.salary).format(
                  "0,0"
                )} + ${numeral(totalBonus).format("0,0")})`,
              },
            ],
            margin: [0, 6, 0, 0],
          },
          {
            // % width
            width: "50%",
            bold: true,
            alignment: "right",
            fontSize: 12,
            text: `${numeral(data.oneEmployee.salary + totalBonus).format(
              "0,0"
            )} ${data.setting.currencyCode}`,
            margin: [0, 6, 0, 0],
          },
        ],
        // optional space between columns
        columnGap: 10,
      },
    ],
    styles: {
      header: {
        fontSize: 24,
        bold: true,
        color: "#ff513f",
        alignment: "center",
      },
      title: {
        fontSize: 12,
        bold: true,
        color: "#292f48",
        alignment: "center",
      },
      anotherStyle: {
        italics: true,
        alignment: "right",
      },
    },
    defaultStyle: {
      fontSize: 12,
      bold: false,
      color: "#292f48",
    },
    // a string or { width: number, height: number }
    pageSize: "A4",

    // by default we use portrait, you can change it to landscape if you wish
    pageOrientation: "landscape",

    // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
    pageMargins: [24, 24, 24, 24],
  };
}
